export const SET_DESKTOP_COLLAPSED = 'SET_DESKTOP_COLLAPSED';
export const setDesktopCollapsed = desktopIsCollapsed => ({ type: SET_DESKTOP_COLLAPSED, desktopIsCollapsed });

const initialState = {
  desktopIsCollapsed: false,
};

export default (state = initialState, action) => {
  const { type, desktopIsCollapsed } = action;

  switch (type) {
    case SET_DESKTOP_COLLAPSED:
      return { ...state, desktopIsCollapsed };

    default:
      return state;
  }
};
